document.addEventListener('DOMContentLoaded', () => {
function updateCard(card){
    const items = card.querySelectorAll('.b2b-size-item');
    let total = 0;
    items.forEach(item => {
        total += Number(item.dataset.quantity || 0);
    });
    const progress = card.querySelector('.b2b-summary__progress');
    const remaining = card.querySelector('.b2b-summary__remaining');
    const status = card.querySelector('.b2b-summary__status');
const button = card.querySelector('.b2b-add-order');
    progress.textContent = `${total} / 6 pares`;
if(total < 6){
    remaining.textContent = `Faltam ${6-total} pares`;
    status.textContent = "";
    status.classList.add('is-pending');
    button.disabled = true;
    button.textContent = "Complete a grade";
}else{
    remaining.textContent = "";
    status.textContent = "✓ Pedido mínimo atingido";
    status.classList.remove('is-pending');
    button.disabled = false;
    button.textContent = "Adicionar ao pedido";
}
}
    document.querySelectorAll('.b2b-size-item').forEach(item => {
        const minus = item.querySelector('.b2b-quantity__minus');
        const plus = item.querySelector('.b2b-quantity__plus');
        const value = item.querySelector('.b2b-quantity__value');
        let quantity = 0;
        plus.addEventListener('click', () => {
            quantity++;
            value.textContent = quantity;
            item.dataset.quantity = quantity;
updateCard(item.closest('.b2b-card'));
        });
        minus.addEventListener('click', () => {
            if(quantity > 0){
                quantity--;
                value.textContent = quantity;
                item.dataset.quantity = quantity;
updateCard(item.closest('.b2b-card'));
            }
        });
    });
});

async function addCardToCart(card, button){
    const items = [];
    card.querySelectorAll('.b2b-size-item').forEach(item => {
        const quantity = Number(item.dataset.quantity);
        if(quantity > 0){
            items.push({
                id: Number(item.dataset.variantId),
                quantity: quantity
            });
        }
    });

    if (items.length === 0) return;

    const textoOriginal = button.textContent;
    button.disabled = true;
    button.textContent = 'Adicionando...';

try {
    const response = await fetch('/cart/add.js', {
    method: 'POST',
    headers: {
        'Content-Type': 'application/json'
    },
    body: JSON.stringify({
        items: items.map(item => ({
            ...item,
            properties: {
                _b2b: 'true'
            }
        }))
    })
});
    if (!response.ok) {
        throw new Error('Erro ao adicionar ao carrinho');
    }

    const cartResp = await fetch('/cart.js');
    const cart = await cartResp.json();

    if (cart.item_count < 36) {
        alert('Adicionado. Faltam ' + (36 - cart.item_count) + ' pares para o mínimo de 36.');
    } else {
        alert('Adicionado ao pedido.');
    }

    location.reload();

} catch (error) {
    console.error(error);
    button.disabled = false;
    button.textContent = textoOriginal;
    alert('Não foi possível adicionar ao pedido. Tente novamente.');
}
}

document.querySelectorAll('.b2b-add-order').forEach(button => {
    button.addEventListener('click', () => {
        const card = button.closest('.b2b-card');
        addCardToCart(card, button);
    });
});